<template>
  <div class="flex flex-row gap-3 items-center cursor-default relative">
    <img
      :src="require(`@/assets/images/icon/${bonus.icon}.webp`)"
      class="w-6 h-6"
      alt=""
    />
    <template v-if="bonus.overlay">
      <img
        :src="require(`@/assets/images/icon/${bonus.overlay}.webp`)"
        class="w-4 h-4 absolute -bottom-1 left-4 shadow-white"
        alt=""
      />
    </template>
    <span
      class="text-sm"
      v-html="bonus.description"
    />
  </div>
</template>

<script>
export default {
  props: {
    bonus: {
      type: Object,
      required: true
    }
  }
};
</script>
